export default __webpack_public_path__ + "static/media/IMG_1808.4aa103e5.jpg";